import * as Yup from 'yup';
import React, { useEffect } from 'react';
import { Container, Form, Label, FormGroup, Row, Input } from 'reactstrap';
import { InputField, Button } from 'src/components';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import { setFromErrors } from 'src/helpers';
import { useCreateDocumentFileUploadMutation } from 'src/rtk/features/setup/documentFileUpload/documentFileUploadApi';
import { useGetLookupDataQuery } from 'src/rtk/features/setup/lookup/lookupDataApi';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { useHistory } from 'react-router-dom';

const initialValues: DocumentFileUpload = {
  document_for: '',
  document_type: '',
  document_name: '',
  file_type: '',
  file_size: 0,
  file_size_unit: '',
  status: false,
};

export const AddDocumentFileUpload = () => {
  const [createDocumentFileUpload, { isSuccess, isError, error }] =
    useCreateDocumentFileUploadMutation();
  
  const history = useHistory();

  const err: CustomError = error as CustomError;

  const fileSizeUnitOptions = [
    { value: 'KB', label: 'KB' },
    { value: 'MB', label: 'MB' },
    { value: 'GB', label: 'GB' },
  ];

  const { data: fileLookup } = useGetLookupDataQuery('file_types');

  const fileTypesOptions: SelectOption[] =
    fileLookup?.data[0].childs.map((item) => ({
      value: item.name,
      label: item.name,
    })) || [];

  const { data: fileUploadDocumentFor } = useGetLookupDataQuery(
    'file_upload_document_for',
  );

  const fileUploadDocumentForOptions: SelectOption[] =
    fileUploadDocumentFor?.data[0].childs.map((item) => ({
      value: item.name,
      label: item.name,
    })) || [];

  const {
    handleSubmit,
    getFieldProps,
    touched,
    errors,
    values,
    handleChange,
    resetForm,
    setErrors,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      document_name: Yup.string().required('Please Enter Document Name'),
    }),

    onSubmit: (values) => {
      createDocumentFileUpload({
        ...values,
      });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Document File Upload created successfully');
      history.push('/setup/document-file-upload/');
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);

  return (
    <div className="page-content">
      <Container fluid>
        <BetterBreadcrumb
          title="Add Document File Upload"
          breadcrumbItem={[
            {
              link: '/setup/document-file-upload/',
              name: 'Document File Upload',
            },
          ]}
        />
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 col-sm-12 ">
            <div className="card mt-3">
              <h5 className="card-header">
                <i className="fa fa-plus me-2" />
                Add Document File
              </h5>
              <div className="card-body">
                <Form
                  autoComplete="off"
                  className="custom-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <Row>
                    <FormGroup className="mb-3">
                      <Label for="document_name">Document Name</Label>
                      <InputField
                        type="text"
                        placeholder="Document Name"
                        invalid={{ errors, touched }}
                        {...getFieldProps('document_name')}
                      />
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <Label for="document_for">Document For</Label>
                      <InputField
                        type="select"
                        name="document_for"
                        options={[
                          // { value: '', label: 'Select Document For' },
                          ...fileUploadDocumentForOptions,
                        ]}
                        invalid={{ errors, touched }}
                        value={values.document_for}
                        onChange={handleChange}
                      />
                    </FormGroup>

                    <FormGroup className="mb-3 col-md-6 col-sm-12">
                      <Label for="document_type">Document Type</Label>
                      <InputField
                        type="text"
                        placeholder="Document Type"
                        invalid={{ errors, touched }}
                        {...getFieldProps('document_type')}
                      />
                    </FormGroup>
                    <FormGroup className="mb-3 col-md-6 col-sm-12">
                      <Label for="file_type">File Type</Label>
                      <InputField
                        type="select"
                        name="file_type"
                        options={[
                          // { value: '', label: 'Select File Type' },
                          ...fileTypesOptions,
                        ]}
                        invalid={{ errors, touched }}
                        value={values.file_type}
                        onChange={handleChange}
                      />
                    </FormGroup>

                    <FormGroup className="md-3 col-md-6 col-sm-12">
                      <Label for="file_size">File Size</Label>
                      <InputField
                        type="number"
                        placeholder="File Size"
                        invalid={{ errors, touched }}
                        {...getFieldProps('file_size')}
                      />
                    </FormGroup>

                    <FormGroup className="md-3 col-md-6 col-sm-12">
                      <Label for="name">File Size Unit</Label>
                      <InputField
                        type="select"
                        name="file_size_unit"
                        options={[
                          // { value: '', label: 'Select File Size Unit' },
                          ...fileSizeUnitOptions,
                        ]}
                        invalid={{ errors, touched }}
                        value={values.file_size_unit}
                        onChange={handleChange}
                      />
                    </FormGroup>

                    <FormGroup className="mb-3">
                      <h6>Active Status</h6>
                      <FormGroup check className="mb-3">
                        <Input
                          type="checkbox"
                          role="check"
                          {...getFieldProps('status')}
                        />
                        <Label check>Active</Label>
                      </FormGroup>
                    </FormGroup>

                    <div className="text-center">
                      <Button className="w-25" type="submit" text="Submit" />
                    </div>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
